"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _lodash = require("lodash");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Use this HOC when using Router Link as a StyledComponent
// and you need to pass props to the StyledComponent that aren't safe to attach to the DOM element
// This avoids the console errors
// const StyledLink = styled(filteredLink(['isDanger']))`
//   color: ${props => props.isDanger ? 'red' : 'black'};
// `;
var filteredLinkHOC = function filteredLinkHOC() {
  var filterProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(filterProps)) throw new Error('filterProps must be an array');
  if (!filterProps.every(function (item) {
    return typeof item === 'string';
  })) throw new Error('filterProps must be an array of strings');
  var FilteredLink = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    var filteredProps = filterProps.length > 0 ? (0, _lodash.omit)(props, filterProps) : props;
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({}, filteredProps, {
      ref: ref
    }));
  });
  FilteredLink.displayName = 'FilteredLink';
  return FilteredLink;
};

var _default = filteredLinkHOC;
exports["default"] = _default;